
import { Mappeable } from './mappeable.model';
import * as _ from 'lodash';

export class AuditTypeExt extends Mappeable {

    idTypeExternalAuditPK: number;
    txtDescription: string;
    mrkActive: boolean;

    constructor(o) {
        super(o);
        this.mrkActive = this.mrkActive ??  false 
    }

    public mapToBack() {
        return {
            txtDescription: this.txtDescription,
            mrkActive: this.mrkActive
        }
    }

}
